import { Checkbox, FormControlLabel } from '@material-ui/core';
import React from 'react';

const MenuLibraryList = (props) => {
  const { listData, onChangeCheckbox, listNameKey, onDragStart } = props;

  const onChange = (e, list, ndx) => {
    return onChangeCheckbox(e, list, ndx);
  };

  return (
    <div className='row ird-menu-lib-section'>
      {listData &&
        listData.length > 0 &&
        listData.map((list, ndx) => (
          <div
            className='col-md-12 mt-1'
            key={list.id}
            draggable
            onDragStart={(e) => onDragStart(e, list, listData)}
          >
            <div className='row'>
              <div className='col-md-2' key={list.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => onChange(e, list, ndx)}
                      checked={list.isChecked || false}
                    />
                  }
                />
              </div>
              <div className='col-md-9 ird-menu-list'>
                <p className='ird-menu-list-name'>{list[listNameKey]}</p>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default MenuLibraryList;
